/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Iconik_Publish_Failed_ErrorInputs */

const en_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish Failed. ${i?.message}`)
};

const fr_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de publication. ${i?.message}`)
};

const de_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veröffentlichung fehlgeschlagen. ${i?.message}`)
};

const it_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pubblicazione non riuscita. ${i?.message}`)
};

const ru_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Публикация не удалась. ${i?.message}`)
};

const es_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publicación fallida. ${i?.message}`)
};

const zh_cn2_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`发布失败。${i?.message}`)
};

const ja_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`公開に失敗しました。${i?.message}`)
};

const hi_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रकाशन विफल। ${i?.message}`)
};

const pt_pt2_iconik_publish_failed_error = /** @type {(inputs: Iconik_Publish_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publicação falhou. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Publish Failed. {message}" |
*
* @param {Iconik_Publish_Failed_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_failed_error = /** @type {((inputs: Iconik_Publish_Failed_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Failed_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_failed_error(inputs)
	if (locale === "de") return de_iconik_publish_failed_error(inputs)
	if (locale === "it") return it_iconik_publish_failed_error(inputs)
	if (locale === "ru") return ru_iconik_publish_failed_error(inputs)
	if (locale === "es") return es_iconik_publish_failed_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_failed_error(inputs)
	if (locale === "ja") return ja_iconik_publish_failed_error(inputs)
	if (locale === "hi") return hi_iconik_publish_failed_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_failed_error(inputs)
	return en_iconik_publish_failed_error(inputs)
});